import React from 'react';
import LocationInfo from '../LocationInfo';

/**
 * Section « Nous trouver » de l'accueil. Enveloppe LocationInfo avec les
 * coordonnées PCC (auparavant en dur dans HomeScreen).
 */
const LOCATION = {
  name: 'Paris Centre Chrétien',
  address: '7 Rue Pascal',
  city: '93120 La Courneuve, France',
  mapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=7+Rue+Pascal,+93120+La+Courneuve',
};

export default function LocationSection({ props = {} } = {}) {
  // Repli sur les coordonnées codées quand un champ n'est pas saisi (3.2).
  const location = {
    name: props.name || LOCATION.name,
    address: props.address || LOCATION.address,
    city: props.city || LOCATION.city,
    mapsUrl: props.mapsUrl || LOCATION.mapsUrl,
  };
  return (
    <div className="mt-4">
      <LocationInfo location={location} />
    </div>
  );
}
